import { getSessionId } from '@/core/sessionId.utilities';
import { SeeqNames } from '@/main/app.constants.seeqnames';
import type { SeeqInternalAxiosRequestConfig } from '@/requests/axios.utilities';

type SessionIdInterceptorConfig = {
  headers: SeeqInternalAxiosRequestConfig['headers'] | Record<string, unknown>;
};

/**
 * HTTP interceptor that adds the current SessionID as a header to all outgoing HTTP requests
 */
export function sessionIdInterceptor<TConfig extends SessionIdInterceptorConfig>(config: TConfig): TConfig {
  config.headers[SeeqNames.API.Headers.InteractiveSessionId] = getSessionId();
  return config;
}
